import {createContext, useContext, useMemo, useState} from 'react'
import type {Dispatch, SetStateAction, PropsWithChildren} from 'react'
import {noop} from '@github-ui/noop'

type ActionsContextProps = {
  actionsOpen: boolean
  setActionsOpen: Dispatch<SetStateAction<boolean>>
}

const ActionsContext = createContext<ActionsContextProps>({
  actionsOpen: false,
  setActionsOpen: noop,
})

export const ActionsProvider = ({children}: PropsWithChildren) => {
  const [actionsOpen, setActionsOpen] = useState(false)
  const contextProps = useMemo(() => ({actionsOpen, setActionsOpen}), [actionsOpen])
  return <ActionsContext.Provider value={contextProps}>{children}</ActionsContext.Provider>
}

export const useListItemActions = () => {
  return useContext(ActionsContext)
}

try{ ActionsContext.displayName ||= 'ActionsContext' } catch {}
try{ ActionsProvider.displayName ||= 'ActionsProvider' } catch {}